export const $postHttp = (url, { data = {}, headers = {} }) => {
    return new Promise((resolve, reject) => {
        return fetch(url, {
            method: "POST",
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json',
                ...headers
            }
        })
            .then((res) => {
                try {
                    const response = res.json();
                    resolve(response);
                } catch (error) {
                    resolve(res);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });
};


export const $getViewInfo = () => {
    return new Promise((resolve, reject) => {
        fetch('https://ipapi.co/json/')
            .then((response) => response.json())
            .then((data) => {
                try {
                    const response = data;
                    resolve(response);
                } catch (error) {
                    resolve(data);
                }
                // console.log(data.ip) // viewer's IP
                // console.log(data.city) // viewer's city
                // console.log(data.region) // viewer's region
                // console.log(data.country) // viewer's country
                // console.log(data.org) // viewer's organization
                // console.log(data.latitude) // viewer's latitude
                // console.log(data.longitude) // viewer's longitude
                // console.log(navigator.userAgent)//viewer's browservision
            })
    })
}
